import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
    selector: '[appTimeAgo]',
    standalone: false
})
export class TimeAgoDirective implements OnInit, OnDestroy {
  @Input('appTimeAgo') timestamp!: number; // Unix timestamp in seconds
  private intervalId!: number;
  private interval: number = 1000;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.updateTime();
    this.intervalId = window.setInterval(
      () => this.updateTime(),
      this.interval,
    );
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private updateTime() {
    const timeAgo = this.timeSince(this.timestamp);
    this.el.nativeElement.textContent = timeAgo;
  }

  private timeSince(timestamp: number): string {
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    const secondsPast = now - timestamp;

    this.interval = secondsPast < 60 ? 1000 : 60000;

    if (secondsPast < 60) {
      return `${secondsPast} sec ago`;
    } else if (secondsPast < 3600) {
      return `${Math.floor(secondsPast / 60)} min ago`;
    } else if (secondsPast < 86400) {
      return `${Math.floor(secondsPast / 3600)} hour ago`;
    } else {
      return `${Math.floor(secondsPast / 86400)} day ago`;
    }
  }
}
